// MarkerClustererAdapter.js
// Adapterklasse zur Entkopplung des Clusterers von der Google Maps-Implementierung

export class MarkerClustererAdapter {
    constructor(clustererLib, mapInstance, options = {}) {
        this.clustererLib = clustererLib; // z.B. MarkerClustererPlus oder ein anderer kompatibler Clusterer
        this.map = mapInstance;
        this.options = options;
        this.clusterer = null;
    }

    initialize() {
        if (!this.clustererLib || !this.map) throw new Error("ClustererLib oder Map nicht gesetzt");

        const clusterOptions = {
          map: this.map,
          ...this.options
        };

        if(this.options.render) {
            clusterOptions.renderer = {
                render: this.options.render
            }
        }

        this.clusterer = new this.clustererLib.MarkerClusterer(clusterOptions);
    }

    addMarkers(markers = []) {
        if (!this.clusterer) throw new Error("Clusterer nicht initialisiert");
        this.clusterer.addMarkers(markers);
    }

    clearMarkers() {
        if (!this.clusterer) return;
        this.clusterer.clearMarkers();
    }

    // Optional: weitere Adaptermethoden, je nach verwendeter Clusterer-Bibliothek
    // z.B. removeMarker(marker), repaint(), getClusters(), etc.

    getInstance() {
        return this.clusterer;
    }
}

// Verwendung in Index:
// import { MarkerClustererAdapter } from './MarkerClustererAdapter.js';
// this.clusterer = new MarkerClustererAdapter(MarkerClustererLib, this.mapInstance, { gridSize: 40 });
// this.clusterer.initialize();
// documentMarkerManager.setClusterer(this.clusterer);
